/**
 * English translations
 */
export default {
    // Auth
    'auth.sign_in': 'Sign in',
    'auth.sign_in_to': 'Sign in to {app}',
    'auth.enter_email_to_continue': 'Enter your email to continue',
    'auth.email_label': 'Email address',
    'auth.email_placeholder': 'you@example.com',
    'auth.continue': 'Continue',
    'auth.checking': 'Checking...',
    'auth.sign_out': 'Sign Out',
    'auth.signing_in': 'Signing in...',
    'auth.signed_in_redirecting': 'Successfully signed in! Redirecting...',
    'auth.signed_in_close_tab': 'Successfully signed in! You can close this tab.',
    'auth.check_email': 'Check your email',
    'auth.sign_in_link_sent': 'We sent a sign-in link to {email}',
    'auth.click_link_to_continue': 'Click the link to continue',
    'auth.first_signup_approval': 'If you\'re signing up for the first time, your request may require approval before we send the sign-in link.',
    'auth.didnt_receive_try_again': 'Didn\'t receive it? Try again',
    'auth.click_link_to_sign_in': 'Click the link in the email to sign in.',
    'auth.resend_email': 'Resend email',
    'auth.use_different_email': 'Use a different email',
    'auth.passkey_available': 'Passkey available',
    'auth.sign_in_with_passkey': 'Sign in with passkey',
    'auth.security_key_required': 'Security key required',
    'auth.use_security_key_to_sign_in': 'Use your security key to sign in to {email}',
    'auth.sign_in_with_security_key': 'Sign in with Security Key',
    'auth.waiting_for_device': 'Waiting for device...',
    'auth.verifying': 'Verifying...',
    'auth.lost_device_access': 'Lost access to your device?',
    'auth.lost_security_key_access': 'Lost access to your security key?',
    'auth.link_opened_different_device': 'Link opened on a different device',
    'auth.enter_verification_code': 'Enter the verification code shown there:',
    'auth.verify_code': 'Verify Code',
    'auth.please_enter_email': 'Please enter your email address',
    'auth.please_enter_valid_email': 'Please enter a valid email address',
    'auth.please_enter_6_digit_code': 'Please enter the 6-digit code',
    'auth.please_enter_valid_6_digit_code': 'Please enter a valid 6-digit code',
    'auth.session_expired': 'Session expired. Please try again.',
    'auth.session_expired_request_new': 'Session expired. Please request a new sign-in link.',
    'auth.signin_replaced': 'This sign-in was replaced by a newer request. Please check your email.',
    'auth.authentication_failed': 'Authentication failed. Please try again.',
    'auth.failed_send_link': 'Failed to send sign-in link. Please try again.',
    'auth.failed_verify_code': 'Failed to verify code. Please try again.',
    'auth.webauthn_not_supported': 'Security keys are not supported in this browser',
    'auth.unexpected_error': 'An unexpected error occurred. Please try again.',
    'auth.invalid_or_missing_token': 'Invalid or missing verification token',
    'auth.verification_failed': 'Failed to verify. Please try again.',
    'auth.keep_signed_in_question': 'Stay signed in?',
    'auth.keep_signed_in_description': 'On a shared or public computer, choose \u201cNot now\u201d \u2014 your session will end after 30 minutes of inactivity.',
    'auth.keep_signed_in_yes': 'Keep me signed in',
    'auth.keep_signed_in_no': 'Not now',

    // Settings
    'settings.title': 'Settings',
    'settings.profile': 'Profile',
    'settings.profile_display_name': 'Display Name',
    'settings.profile_display_name_placeholder': 'Enter your name',
    'settings.profile_display_name_help': 'This name will be shown instead of your email',
    'settings.profile_not_set': 'Not set',
    'settings.profile_avatar': 'Avatar',
    'settings.profile_avatar_upload': 'Upload',
    'settings.profile_avatar_help': 'JPG, PNG, GIF or WebP. Max 2MB.',
    'settings.profile_avatar_too_large': 'File size must be 2MB or less',
    'settings.profile_avatar_invalid_type': 'File must be JPG, PNG, GIF, or WebP',
    'settings.profile_avatar_updated': 'Avatar updated',
    'settings.profile_avatar_removed': 'Avatar removed',
    'settings.profile_avatar_remove_confirm': 'Remove your avatar?',
    'settings.profile_timezone': 'Timezone',
    'settings.profile_timezone_select': 'Select Timezone',
    'settings.profile_timezone_search': 'Search timezones...',
    'settings.profile_updated': 'Profile updated',
    'settings.language': 'Language',
    'settings.language_description': 'Choose your preferred language',
    'settings.sessions': 'Sessions',
    'settings.sessions_description': 'Manage your active sessions',
    'settings.security': 'Security',
    'settings.security_description': 'Manage your security keys and passkeys',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.welcome': 'Welcome, {name}',
    'dashboard.edit_profile': 'Edit Profile',
    'dashboard.member_since': 'Member since {date}',
    'dashboard.services': 'Services',
    'dashboard.account': 'Account',
    'dashboard.organizations_title': 'Organizations',
    'dashboard.organizations_description': 'Manage your organizations',
    'dashboard.domains_title': 'Domains',
    'dashboard.domains_description': 'Configure domains and DNS',
    'dashboard.mailboxes_title': 'Mailboxes',
    'dashboard.mailboxes_description': 'Email accounts and storage',
    'dashboard.aliases_title': 'Aliases',
    'dashboard.aliases_description': 'Email forwarding rules',
    'dashboard.settings_title': 'Settings',
    'dashboard.settings_description': 'Profile and security',
    'dashboard.support_title': 'Support',
    'dashboard.support_description': 'Contact support',

    // Support
    'support.title': 'Support',
    'support.description': 'Have a question or need help? Send us a message and we\'ll reply to {email}. If you\'d prefer to be reached at a different address or would like a callback, please mention it in your message.',
    'support.organization': 'Organization',
    'support.no_organization': 'General inquiry (no organization)',
    'support.organization_help': 'Optional. Select if your request is about a specific organization.',
    'support.subject': 'Subject',
    'support.message': 'Message',
    'support.message_placeholder': 'Describe your question or issue...',
    'support.send': 'Send',
    'support.sending': 'Sending...',
    'support.sent': 'Message sent',
    'support.sent_description': 'We\'ve received your message and will get back to you.',
    'support.send_another': 'Send another message',
    'support.fields_required': 'Subject and message are required.',
    'support.send_error': 'Failed to send message. Please try again.',

    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.add': 'Add',
    'common.remove': 'Remove',
    'common.confirm': 'Confirm',
    'common.ok': 'OK',
    'common.close': 'Close',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',

    // Errors
    'error.generic': 'Something went wrong. Please try again.',
    'error.network': 'Network error. Please check your connection.',
    'error.unauthorized': 'You are not authorized to perform this action.',
    'error.not_found': 'The requested resource was not found.',

    // Admin forward conversion
    "admin.forward_conversion.title": "Convert Forward to Mailbox",
    "admin.forward_conversion.button": "Convert",
    "admin.forward_conversion.description": "Convert a forward to a mailbox alias when its destination is an active mailbox in this organization. The address and its history are preserved.",
    "admin.forward_conversion.empty": "No eligible forwards. The destination must be an active mailbox in this organization, without an existing mailbox route for the same address.",
    "admin.forward_conversion.search": "Search addresses...",
    "admin.forward_conversion.confirm": "Convert {email} to a mailbox alias for {destination}? The alias will stay attached to this mailbox if its email address changes.",
    "admin.forward_conversion.success": "Forward converted to mailbox",
    "admin.forward_conversion.failed": "Conversion failed",
    "admin.forward_conversion.stale": "Forward is no longer eligible for conversion. Reload the domain page.",
    "admin.forward_conversion.invalid": "address_id and mailbox_id must be positive integers",
    "admin.forward_conversion.event": "Forward Converted to Mailbox",
} as const;
